module.exports = __webpack_public_path__ + "img/ShareButton.1b93efca.svg";